import { render, staticRenderFns } from "./hapusangsuran.vue?vue&type=template&id=72caafc5&scoped=true&"
import script from "./hapusangsuran.vue?vue&type=script&lang=js&"
export * from "./hapusangsuran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72caafc5",
  null
  
)

export default component.exports